// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2024-06-12 00:48:57 +0200 (Wed, 12 Jun 2024) $
//  Author    : Olli Powroznik
//  Worker    : $Author: o.powroznik $
//  Revision  : $Rev: 143476 $
//  Purpose   : utility functions
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import log from 'uix/logging'
import clsx from 'clsx'

// ---Local imports
import S from './tiles.scss'

export const Tiles = ({children, gap, columns, type, position}) => {
  let gapS = gap ? {'--wiki-tiles-gap': `${gap}`} : null
  let columnS = columns ? {'--wiki-tiles-columns': columns} : null

  return (
    <div
      style={{...columnS, ...gapS}}
      className={clsx(S.tiles, S[`c${columns}`], S[type], S[position])}
    >
      {children}
    </div>
  )
}

export const Tile = ({caption, img}) => {
  let imgS = img ? {'--wiki-tile-bgImg': `url(${img})`} : null
  return (
    <div style={imgS} className={S.tile}>
      <div className={S.caption}>{caption}</div>
      <div className={S.bg}></div>
    </div>
  )
}
